// extracted by mini-css-extract-plugin
export default {"risks":"styles_risks__aaFQT"};